module.exports = __webpack_public_path__ + "static/sec3-9a05734c826002da856a2200024785fe.png";